import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import Header from '../../containers/header';

import PrimaryNavigation from '../../containers/primary-navigation';
import SiteSearch from '../../containers/site-search';
import GlobalNavigation from '../../blocks/global-navigation';
import MyMazda from '../../containers/my-mazda';

const HeaderBlock = props => <Header {...props} />;
HeaderBlock.displayName = 'Header';

export default withDynamicComponents({
  componentWhitelist: [
    PrimaryNavigation,
    SiteSearch,
    GlobalNavigation,
    MyMazda,
  ],
  mapInputToOutput: [
    ['primaryNavigation', 'primaryNavigation'],
    ['siteSearch', 'siteSearch'],
    ['globalNavigation', 'globalNavigation'],
    ['myMazda', 'myMazda'],
  ],
})(HeaderBlock);



// WEBPACK FOOTER //
// ./src/blocks/header/index.jsx